import Vue from "vue";
import Router from "vue-router";
import Register from "@/components/Register";
import Login from "@/components/Login";
import Companies from "@/components/Companies";
import Groups from "@/components/Groups";
import Sites from "@/components/Sites";
import Buildings from "@/components/_buildings";
import Users from "@/components/Users";
import Roles from "@/components/Roles";
import Boluses from "@/components/Boluses";
import NewDashboard from "@/components/_dashboard";
import NewCowProfile from "@/components/_cow-profile";
import NewCows from "@/components/_cows";
import ThiSensors from "@/components/_thi-sensors";
import ThiSensorProfile from "@/components/_thi-sensor-profile";
import NewData from "@/components/_data";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import Settings from "@/components/Settings";
import NewReport from "@/components/_report";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },

    // new routes
    {
      path: "/new-dashboard",
      name: "dashboard",
      component: NewDashboard
    },
    {
      path: "/cows/:cow_id",
      name: "cow-details",
      component: NewCowProfile
    },
    {
      path: "/cows",
      name: "cows",
      component: NewCows
    },
    {
      path: "/thi-sensors/:thi_sensor_id",
      name: "thi-sensor-details",
      component: ThiSensorProfile
    },
    {
      path: "/thi-sensors",
      name: "thi-sensors",
      component: ThiSensors
    },
    {
      path: "/data",
      name: "data",
      component: NewData
    },
    {
      path: "/report",
      name: "report",
      component: NewReport
    },

    // old routes
    {
      path: "/companies",
      name: "companies",
      component: Companies
    },
    {
      path: "/groups",
      name: "groups",
      component: Groups
    },
    {
      path: "/sites",
      name: "sites",
      component: Sites
    },
    {
      path: "/barns",
      name: "buildings",
      component: Buildings
    },
    {
      path: "/users",
      name: "users",
      component: Users
    },
    {
      path: "/roles",
      name: "roles",
      component: Roles
    },
    {
      path: "/boluses",
      name: "boluses",
      component: Boluses
    },
    {
      path: "/privacyPolicy",
      name: "privacy-policy",
      component: PrivacyPolicy
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "*",
      redirect: "login"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/plugins/router/index.js